
const setUpper = new Set(['activityId', 'badgeId', 'actionId']);
const setLower = new Set(['coreId']);

const normalizeField = (field, value) => {
  if(setLower.has(field)) {
    return value.toLowerCase();
  }
  if(setUpper.has(field)) {
    return value.toUpperCase();
  }
  return value;
}

const makeActivity = (coreId, activityId, date, comment, hours, id = null) => {
  coreId = normalizeField('coreId', coreId);
  activityId = normalizeField('activityId', activityId);
  date = normalizeField('date', date);
  comment = normalizeField('comment', comment);
  hours = normalizeField('hours', hours);
  id = normalizeField('id', id);
  return {
    id,
    coreId,
    activityId,
    date,
    comment,
    hours
  }
}

const makeAchievement = (coreId, actionId, badgeId, date, comment, id = null) => {
  coreId = normalizeField('coreId', coreId);
  actionId = normalizeField('actionId', actionId);
  badgeId = normalizeField('badgeId', badgeId);
  date = normalizeField('date', date);
  comment = normalizeField('comment', comment);
  id = normalizeField('id', id);
  return {
    id,
    coreId,
    actionId,
    badgeId,
    date,
    comment
  }
}

const makeActivityObj = (obj) => {
    return {
        coreId: normalizeField('coreId', obj.coreId),
        activityId: normalizeField('activityId',obj.activityId),
        date: normalizeField('date',obj.date),
        comment: normalizeField('comment',obj.comment),
        hours: normalizeField('hours',obj.hours),
        id: normalizeField('id',obj.id) || null
    }
}

const makeAchievementObj = (obj) => {
    return {
        coreId: normalizeField('coreId', obj.coreId),
        actionId: normalizeField('actionId',obj.actionId),
        badgeId: normalizeField('badgeId',obj.badgeId),
        date: normalizeField('date', obj.date),
        comment: normalizeField('comment', obj.comment),
        id: normalizeField('id', obj.id) || null
    }
}

const checkActivity = (activity) => {
    if (activity.activityId === "OTHERACTIV" && activity.comment === "") {
      return false
    }

    if (!activity.coreId || !activity.activityId || !activity.date || !activity.hasOwnProperty('hours')) {
        return false;
    }

    if (activity.hours < 0 ) {
        return false;
    }

    return true;
}

const checkAchievement = (achievement) => {
    if (!achievement.coreId || !achievement.badgeId || !achievement.date) {
        return false;
    }

    return true;
}

export { normalizeField, makeActivity, makeAchievement, makeActivityObj, makeAchievementObj, checkActivity, checkAchievement }
